"use strict";
// This file contains "general-purpose" code; i.e. code that isn't specific to
// math rendering, but just happens to only be used in this package (so far).
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazy = exports.createSpanWithRedText = exports.convertCaughtValueToError = void 0;
// convert a string or Error to an Error
function convertCaughtValueToError(e) {
    if (e instanceof Error) {
        return e;
    }
    return new Error(String(e));
}
exports.convertCaughtValueToError = convertCaughtValueToError;
function createSpanWithRedText(content) {
    const span = document.createElement("span");
    span.appendChild(document.createTextNode(content));
    span.style.color = "red";
    return span;
}
exports.createSpanWithRedText = createSpanWithRedText;
// lazy() wraps a zero-argument function in a cache, ensuring that expensive or
// side-effecting computations inside the wrapped function only happen once, on
// the first call to the lazy function. A separate cache is created for each
// invocation of lazy().
function lazy(f) {
    let cache;
    return () => {
        if (cache == null) {
            cache = f();
        }
        return cache;
    };
}
exports.lazy = lazy;
